//Style
import '../scss/style.scss';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import Lenis from 'lenis'
import {RangeSlider} from "./range-slider";
import {SplitText} from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger,SplitText)

// Import Swiper e i suoi stili base
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination'; // Importa lo stile della paginazione
import { Pagination, Manipulation, Navigation, Controller } from 'swiper/modules';


// Initialize Lenis
import 'lenis/dist/lenis.css'

const lenis = new Lenis({
    autoRaf: true,
    lerp: 0.2,
    duration: 1.3
});

// Listen for the scroll event and log the event data
lenis.on('scroll', (e) => {

    if (e.animatedScroll >= 96) {

        document.querySelector('.header').classList.add('sticky');

        if (e.direction == 1) {
            document.querySelector('.header').classList.add('hide')
        }

        if (e.direction == -1) {
            document.querySelector('.header').classList.remove('hide')
        }

    } else {
        document.querySelector('.header').classList.remove('sticky')
    }

});

//Init range
customElements.define('range-slider', RangeSlider);

function simulateClick(elem) {
    // Create our event (with options)
    var evt = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
    });
    // If cancelled, don't dispatch our event
    var canceled = !elem.dispatchEvent(evt);
};


window.addEventListener('resize', () => {

    if (document.querySelectorAll('.block-prod__list-banner').length>0) {
        gsap.set('.block-prod__list-banner',{
            height: () => {
                return document.querySelector('.block-prod__list-box-ct').clientHeight
            }
        })
    }

})

document.addEventListener('DOMContentLoaded', () => {

    var tlMenu = gsap.timeline({
        paused: true
    });


    tlMenu.to('.site-menu',{
        y: 0,
        yPercent: 0,
        duration: .4
    })
    .add('opened')
    .to('.site-menu a span',{
        opacity: '1',
        x: 0,
        xPercent: 0,
        stagger: 0.1
    },'opened')


    document.querySelector('.header__mm').addEventListener('click',()=>{
        if (document.querySelector('.header__mm').classList.contains('opened')) {

            document.querySelector('.header__mm').classList.remove('opened');
            document.querySelector('.header').classList.remove('menu-opened');
            tlMenu.reverse()

        } else {
            document.querySelector('.header__mm').classList.add('opened');
            document.querySelector('.header').classList.add('menu-opened');
            tlMenu.play()
        }
    })



    if (document.querySelectorAll('.block-prod__filters').length>0) {
        ScrollTrigger.create({
            trigger: '.block-prod__filters',
            start: 'top top',
            onEnter: (self) => {
                document.querySelector('.block-prod__filters').classList.add('sticky')
            },
            onEnterBack: (self) => {
                document.querySelector('.block-prod__filters').classList.remove('sticky')
            },
            markers: false
        });
    }





    if (document.querySelectorAll('.block-prod__list-banner').length>0) {
        gsap.set('.block-prod__list-banner',{
            height: () => {
                return document.querySelector('.block-prod__list-box-ct').clientHeight
            }
        })
    }

    // js media query
    let mm = gsap.matchMedia();
    let isMobile = true;
    mm.add("(min-width: 992px)", () => {
        isMobile = false;
    });

    gsap.to('body',{
        duration: 1.5,
        opacity: 1,
        delay: 1,
    })

    /*
    if (document.querySelectorAll('.page-template-page-hlight').length>0) {
        document.querySelector('.header').classList.add('light')
        document.querySelector('.header').classList.add('light-mobile')
    }

    if (document.querySelectorAll('.tax-pa_linee').length>0) {
        document.querySelector('.header').classList.add('light')
        document.querySelector('.header').classList.add('light-mobile')
    }
    */

    document.querySelector('.header').classList.add('light')
    document.querySelector('.header').classList.add('light-mobile')



    const marquee = document.querySelectorAll('.marquee')

    if(!marquee) return

    marquee.forEach(item => {
        const marqueeInner = item.querySelector('.marquee__inner')
        const marqueeContent = marqueeInner.querySelector('.marquee__content')

        // Duration
        const duration = item.getAttribute('data-marquee-duration')

        // Element Clone
        const marqueeContentClone = marqueeContent.cloneNode(true)
        marqueeInner.append(marqueeContentClone)

        // Marquee animation
        const marqueeContentAll = marqueeInner.querySelectorAll('.marquee__content')
        marqueeContentAll.forEach(element => {
            gsap.to(element, {
                x: "-101%",
                repeat: -1,
                duration: duration,
                ease: 'linear'
            })
        })
    })



    if (document.querySelectorAll('.header__menu').length>0) {

        document.querySelectorAll('.header__menu a').forEach(el=>{
            el.addEventListener('mouseenter',()=>{
                if (!isMobile) {
                    if (el.classList.contains('has-sub')) {
                        console.log(el.dataset.sub);
                        document.querySelector('.header').classList.add('sub-opened');
                        document.querySelector('#'+el.dataset.sub).classList.add('active')
                    } else {

                        document.querySelector('.header').classList.remove('sub-opened');

                        document.querySelectorAll('.header__sub').forEach(sub=>{
                            sub.classList.remove('active')
                        })


                    }
                }
            });

        })

        document.querySelectorAll('.header__sub').forEach(el=>{

            el.addEventListener('mouseleave',()=>{
                if (!isMobile) {
                    el.classList.remove('active');
                    document.querySelector('.header').classList.remove('sub-opened');
                }
            });
        })

    }

    if (document.querySelectorAll('.site-menu').length>0) {

        document.querySelectorAll('.nav-link-mobile').forEach(el=>{
            el.addEventListener('click',()=>{
                if (el.classList.contains('has-sub')) {
                    document.querySelector('#'+el.dataset.sub+'-mobile').classList.add('active')
                }
            });
        })

        document.querySelectorAll('.header__sub-back').forEach(el=>{
            el.addEventListener('click',()=>{

                document.querySelectorAll('.header__sub.mobile ').forEach(sub=>{

                    sub.classList.remove('active')

                })

            });
        })

    }


    if (document.querySelectorAll('.block-hero__carousel').length > 0) {

        document.querySelectorAll('.block-hero__carousel').forEach(el=>{

            let heroSlider = new Swiper(el, {
                slidesPerView: 1,
                modules: [Navigation],
                navigation: {
                    nextEl: '.block-hero__carousel-next',
                    prevEl: '.block-hero__carousel-prev',
                },
            });

        })


    }


    if (document.querySelectorAll('.block-bestseller').length > 0) {

        document.querySelectorAll('.block-bestseller').forEach(el=>{

            let bst = el.querySelector('.block-bestseller__t');
            let bsc = el.querySelector('.block-bestseller__carousel');
            let bscn = el.querySelector('.block-bestseller__carousel-next');
            let bscp = el.querySelector('.block-bestseller__carousel-prev');

            gsap.to(bst,{
                opacity: 1,
                scrollTrigger: {
                    trigger: el,
                    start: 'center bottom',

                }
            })

            gsap.to(bsc,{
                opacity: 1,
                scrollTrigger: {
                    trigger: el,
                    start: 'center bottom',

                }
            })

            let bestSeller = new Swiper(bsc, {
                slidesPerView: 1.5,
                modules: [Navigation],
                navigation: {
                    nextEl: bscn,
                    prevEl: bscp,
                },
                breakpoints: {
                    992: {
                        slidesPerView: 4
                    },
                }
            });

        });


    }

    if (document.querySelectorAll('.block-related').length > 0) {

        document.querySelectorAll('.block-related').forEach(el=>{

            let t = el.querySelector('.block-related__t');
            let c = el.querySelector('.block-related__carousel');
            let cn = el.querySelector('.block-related__carousel-next');
            let cp = el.querySelector('.block-related__carousel-prev');

            gsap.to(t,{
                opacity: 1,
                scrollTrigger: {
                    trigger: el,
                    start: 'center bottom',
                }
            })

            gsap.to(c,{
                opacity: 1,
                scrollTrigger: {
                    trigger: el,
                    start: 'center bottom',
                }
            })

            let relatedSlider = new Swiper(c, {
                slidesPerView: 1.5,
                modules: [Navigation],
                navigation: {
                    nextEl: cn,
                    prevEl: cp,
                },
                breakpoints: {
                    992: {
                        slidesPerView: 4
                    },
                }
            });

        })




    }


    if (document.querySelectorAll('.block-elements').length > 0) {

        document.querySelectorAll('.block-elements').forEach(el=>{

            let vc = el.querySelector('.block-elements__vc');
            let elc = el.querySelector('.block-elements__carousel');
            let elbc = el.querySelector('.block-elements__bc');

            let vcSwiper = new Swiper(vc, {
                slidesPerView: 1,
                modules: [Navigation,Controller],
            });


            let elementsSlider = new Swiper(elc, {
                slidesPerView: 1,
                modules: [Navigation,Controller],
                navigation: {
                    nextEl: '.block-elements__carousel-next',
                    prevEl: '.block-elements__carousel-prev',
                },
            });

            let elementsBigSlider = new Swiper(elbc, {
                slidesPerView: 1,
                modules: [Navigation,Controller],
                navigation: {
                    nextEl: '.block-elements__bc-next',
                    prevEl: '.block-elements__bc-prev',
                },
            });

            elementsSlider.on('slideChange', function () {
                const activeSlide = elementsSlider.slides[elementsSlider.activeIndex];
                const color = activeSlide.getAttribute('data-color');

                gsap.to('.block-elements',{
                    backgroundColor:color,
                    overwrite: true
                })
            });




            elementsSlider.controller.control = elementsBigSlider
            elementsBigSlider.controller.control = vcSwiper


        })


    }


    if (document.querySelectorAll('.block-highlight').length > 0) {


        document.querySelectorAll('.block-highlight').forEach(el=>{

            mm.add("(min-width: 992px)", () => {

                var bhtl = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        start: 'top bottom',
                        end: 'bottom bottom',
                        scrub: true
                    }
                })

                bhtl
                    .add('start')
                    .to(el.querySelector('.block-highlight__t'),{
                        x: 0,
                        xPercent: 0,
                        opacity: 1,
                    },'start')
                    .to(el.querySelector('.block-highlight__boxes'),{
                        x: 0,
                        xPercent: 0,
                        opacity: 1,

                    },'start')

            })

            mm.add("(max-width: 991px)", () => {

                var bhtl = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        start: 'top bottom',
                        end: 'top+=25% bottom',
                        scrub: true,
                        markers: false
                    }
                })

                bhtl
                    .add('start')
                    .to(el.querySelector('.block-highlight__t'),{
                        x: 0,
                        xPercent: 0,
                        opacity: 1,

                    },'start')
                    .to(el.querySelector('.block-highlight__boxes'),{
                        x: 0,
                        xPercent: 0,
                        opacity: 1,
                    },'start')

            })



        })







    }

    if (document.querySelectorAll('.block-textroll').length > 0) {

        document.querySelectorAll('.block-textroll').forEach(el=>{

            gsap.to(el.querySelector('.block-textroll__t-top'),{
                x: 0,
                xPercent: 0,
                opacity: 1,
                scrollTrigger: {
                    trigger: el,
                    start: 'center bottom',
                    end: 'bottom bottom',
                    scrub: true
                }
            })

            gsap.to(el.querySelector('.block-textroll__t-bottom'),{
                x: 0,
                xPercent: 0,
                opacity: 1,
                scrollTrigger: {
                    trigger: el,
                    start: 'center bottom',
                    end: 'bottom bottom',
                    scrub: true
                }
            })

            gsap.to(el.querySelector('.block-textroll__sub'),{
                opacity: 1,
                scrollTrigger: {
                    trigger: el,
                    start: 'center+=5% bottom',
                    end: 'bottom bottom',
                    scrub: true
                }
            })

            gsap.to(el.querySelector('.block-textroll__txt'),{
                opacity: 1,
                scrollTrigger: {
                    trigger: el,
                    start: 'center+=10% bottom',
                    end: 'bottom bottom',
                    scrub: true
                }
            })

            gsap.to(el.querySelector('.block-textroll__cta'),{
                opacity: 1,
                scrollTrigger: {
                    trigger: el,
                    start: 'center+=35% bottom',
                    end: 'bottom bottom',
                    scrub: true
                }
            })


        })





    }

    if (document.querySelectorAll('#products-container').length>0) {

        document.getElementById('products-container').addEventListener('click', function (e) {
            // Verifica se il clic è su un pulsante "less"
            if (e.target.classList.contains('less')) {
                const quantityInput = e.target.closest('.block-prod__list-quantity').querySelector('input');
                let currentValue = parseInt(quantityInput.value);
                if (currentValue > 1) {
                    quantityInput.value = currentValue - 1;
                }
            }

            // Verifica se il clic è su un pulsante "more"
            if (e.target.classList.contains('more')) {
                const quantityInput = e.target.closest('.block-prod__list-quantity').querySelector('input');
                let currentValue = parseInt(quantityInput.value);
                if (currentValue < 10) {
                    quantityInput.value = currentValue + 1;
                }
            }
        });



    }

    if (document.querySelectorAll('.accordion').length>0) {

        document.querySelectorAll('.accordion').forEach(el=>{

            let groups = gsap.utils.toArray(".accordion-group",el);
            let menus = gsap.utils.toArray(".accordion-menu",el);
            let isAniMenu = false;

            menus.forEach(menu => {
                menu.addEventListener("click", () => toggleMenu(menu));
            });

            if (typeof (el.dataset.firstopen) != 'undefined') {
                toggleMenu(menus[0]);
            }

            function toggleMenu(clickedMenu) {
                if (clickedMenu.parentNode.classList.contains('active')) {

                    if (isAniMenu == false) {
                        isAniMenu = true

                        let t = clickedMenu.parentNode.querySelector('.accordion-content');
                        gsap.to(t,{
                            height: '0px',
                            onComplete: () => {
                                isAniMenu = false
                                clickedMenu.parentNode.classList.remove('active');
                            }
                        })
                    }


                } else {
                    if (isAniMenu == false) {
                        isAniMenu = true
                        groups.forEach(group => {
                            group.classList.remove('active');
                        });
                        clickedMenu.parentNode.classList.add('active');
                        let t = clickedMenu.parentNode.querySelector('.accordion-content');
                        var tl = gsap.timeline({
                            onComplete: () => {
                                isAniMenu = false
                            }
                        });

                        tl
                        .add('start')
                        .to('.accordion-content',{
                            height: '0px',
                        },'start')
                        .to(t,{
                            overwrite: true,
                            height: 'auto',
                        },'start')
                    }

                }
            }



        });

    }

    if (document.querySelectorAll('.block-prod__fb').length>0) {

        var ftl = gsap.timeline({
            paused: true,
            onStart: () => {
                document.querySelector('.filters').classList.add('opened')
                gsap.set('.filters',{
                    display: 'block'
                })
            },
            onReverseComplete: () => {
                gsap.set('.filters',{
                    display: 'none'
                })
                document.querySelector('.filters').classList.remove('opened')
            }
        });

        ftl
        .to('.filters',{
            opacity: 1
        })
        .to('.filters__sidebar',{
            x: 0,
            xPercent: 0
        })


        document.querySelector('.block-prod__fb').addEventListener('click',()=>{

            ftl.play()


        })

        document.querySelector('.filters__c').addEventListener('click',()=>{

            ftl.reverse()


        })








        document.querySelector('.filters__apply').addEventListener('click', () => {
            // Range Slider
            let rs = document.querySelector('range-slider');
            let [minPrice, maxPrice] = [rs.value[0],rs.value[1]]

            // Costruzione della nuova URL
            let currentURL = new URL(window.location.href);
            let params = currentURL.searchParams;

            // Ordina per
            let orderBy = document.querySelector('input[name="orderby"]:checked');
            if (orderBy) {
                params.set('orderby', orderBy.value);
            }

            // Categorie (checkbox)
            let selectedCategories = Array.from(document.querySelectorAll('input[name^="category"]:checked')).map(input => input.id);
            if (selectedCategories.length > 0) {
                params.set('category', selectedCategories.join(','));
            }

            // Linee (checkbox)
            let selectedLinee = Array.from(document.querySelectorAll('input[name^="linea"]:checked')).map(input => input.id);
            if (selectedLinee.length > 0) {
                params.set('linea', selectedLinee.join(','));
            }

            // Prezzo
            params.set('price_min', minPrice);
            params.set('price_max', maxPrice);

            // Redirect alla nuova URL
            //document.querySelector('.filters__apply').dataset.url = currentURL.toString();
            document.querySelector('.filters__apply').dataset.url = params.toString();
            ftl.reverse()

            console.log(window.filtersUrl+'&'+params.toString())

            fetch(window.filtersUrl+'&'+params.toString(), {
                method: 'GET',
                credentials: 'same-origin'
            })

        .then(res => res.text())
                .then(data => {
                    const container = document.getElementById('products-container');
                    container.innerHTML = '';
                    container.insertAdjacentHTML('beforeend', data);



                    document.getElementById('load-more').dataset.page = 2;

                    const shownCount = document.getElementById('shown-count');
                    shownCount.textContent = container.querySelectorAll('.product').length;


                });

        });



    }

    if (document.querySelectorAll('.block-ingredients__carousel').length>0) {
        let ingredientsSlider = new Swiper('.block-ingredients__carousel', {
            slidesPerView: 2.5,
            spaceBetween: 8,
            breakpoints: {
                992: {
                    slidesPerView: 5.5
                },
            }
        });
    }

    if (document.querySelectorAll('.single-prod__carousel').length>0) {
        let singleProdSwiper = new Swiper('.single-prod__carousel', {
            slidesPerView: 1,
            modules: [Pagination],
            pagination: {
                el: '.single-prod__carousel-swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    }


    if (document.querySelectorAll('.block-parallax').length > 0) {

        document.querySelectorAll('.block-parallax').forEach(el=>{

            let imgA = el.querySelector('.block-parallax__img--1 img');
            let imgB = el.querySelector('.block-parallax__img--2 img');

            gsap.to(imgB, {
                yPercent: () => {

                    if (isMobile) {
                        return 25
                    }

                    return 50;
                },
                scrollTrigger: {
                    trigger: el,
                    start: 'top bottom',
                    end: '+=200%',
                    scrub: true,
                }
            })

            gsap.to(imgA, {
                yPercent: -50,
                scrollTrigger: {
                    trigger: el,
                    start: 'top bottom',
                    end: '+=200%',
                    scrub: true,
                }
            })

        })


    }

    if (document.querySelectorAll('.block-video-image').length > 0) {

        document.querySelectorAll('.block-video-image').forEach(el=>{

            let img = el.querySelector('.block-video-image__img img');
            let video = el.querySelector('.block-video-image__v');

            gsap.to(img, {
                scale: 1.5,
                scrollTrigger: {
                    trigger: el,
                    start: 'top top',
                    end: '+=200%',
                    scrub: true,
                }
            })
            gsap.to(video, {
                scale: 1,
                scrollTrigger: {
                    trigger: el,
                    start: 'top top',
                    end: '+=200%',
                    scrub: true,
                }
            })

        })
    }

    if (document.querySelectorAll('.block-textp').length > 0) {

        if (!isMobile) {

        document.querySelectorAll('.block-textp').forEach(el=>{

            let r1 = el.querySelector('.block-textp__t--r1');
            let r2 = el.querySelector('.block-textp__t--r2');
            let r3 = el.querySelector('.block-textp__t--r3');
            let img = el.querySelector('.block-textp__img img');

            gsap.to(img, {
                y: '-=100px',
                scrollTrigger: {
                    trigger: el,
                    start: 'top bottom',
                    end: '+=200%',
                    scrub: true,
                }
            })


            gsap.to(r1, {
                x: '+=100px',
                scrollTrigger: {
                    trigger: el,
                    start: 'top bottom',
                    end: '+=200%',
                    scrub: true,
                }
            })

            gsap.to(r2, {
                x: '-=100px',
                scrollTrigger: {
                    trigger: el,
                    start: 'top bottom',
                    end: '+=200%',
                    scrub: true,
                }
            })

            gsap.to(r3, {
                x: '+=50px',
                scrollTrigger: {
                    trigger: el,
                    start: 'top bottom',
                    end: '+=200%',
                    scrub: true,
                }
            })



        })

        }


    }



    if (document.querySelectorAll('.open-search').length>0) {

        let $ss = document.querySelector('.site-search__sub');

        const handleEnterKey = ({
                                    key,
                                    target
                                }) => {
            // Only if the enter key is pressed and the target is an "enter-able" input
            if (key == 'Enter') {
                simulateClick($ss)
            }
        }

        document.querySelector('.site-search__input-cta').addEventListener('click',(ev)=>{

            simulateClick($ss)

        });

        document.querySelector('.site-search__close').addEventListener('click',()=>{
            gsap.to('.site-search',{
                y:0,
                yPercent:-100
            })
        });

        document.querySelectorAll('.open-search').forEach(el=>{
            el.addEventListener('click',()=>{
                gsap.to('.site-search',{
                    y:0,
                    yPercent:0
                })
            });
        })



    }


})
